import { ComponentWithChildren } from 'modules/common/types';
import { createContext, useContext } from 'react';

import { ContextType } from './type';
import { useProviderValue } from './value';

const EditAppointmentsModalContext = createContext<ContextType | null>(null);

const EditAppointmentsModalProvider: ComponentWithChildren = ({ children }) => {
  const providerValue = useProviderValue();

  return (
    <EditAppointmentsModalContext.Provider value={providerValue}>
      {children}
    </EditAppointmentsModalContext.Provider>
  );
};

export const useEditAppointmentsModalContext = () => {
  const context = useContext(EditAppointmentsModalContext);
  if (context === undefined) {
    throw new Error(
      'the useEditAppointmentsModalContext should be used within EditAppointmentsModalProvider!'
    );
  }

  return context;
};

export default EditAppointmentsModalProvider;
